import apiTrainingsTemplate from '@/api/trainings-template'

const state = {
  data: [],
  total: 0,
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getTrainingsTemplateStart: '[trainings template] Get training template start',
  getTrainingsTemplateSuccess:
    '[trainings template] Get trainings template success',
  getTrainingsTemplateFailure:
    '[trainings template] Get trainings template failure',

  getTrainingsTemplateSchoolIdStart:
    '[trainings template] Get trainings template schoolId start',
  getTrainingsTemplateSchoolIdSuccess:
    '[trainings template] Get trainings template schoolId success',
  getTrainingsTemplateSchoolIdFailure:
    '[trainings template] Get trainings template schoolId failure',
}

export const actionTypes = {
  getTrainingsTemplate: '[trainings template] Get trainings template',
  getTrainingsTemplateSchoolId:
    '[trainings template] Get trainings template schoolId',
}

const mutations = {
  [mutationTypes.getTrainingsTemplateStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTrainingsTemplateSuccess](state, payload) {
    state.data = payload

    state.isLoading = false
  },

  [mutationTypes.getTrainingsTemplateFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.getTrainingsTemplateSchoolIdStart](state) {
    state.total = 0
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTrainingsTemplateSchoolIdSuccess](state, payload) {
    state.data = payload.data ? payload.data : payload
    state.total = payload.total ? payload.total : 0
    state.isLoading = false
  },

  [mutationTypes.getTrainingsTemplateSchoolIdFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getTrainingsTemplate](context) {
    context.commit(mutationTypes.getTrainingsTemplateStart)
    return new Promise((resolve) => {
      apiTrainingsTemplate
        .getTrainingsTemplate()
        .then((response) => {
          context.commit(
            mutationTypes.getTrainingsTemplateSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainingsTemplateFailure)
        })
    })
  },

  [actionTypes.getTrainingsTemplateSchoolId](context, params) {
    context.commit(mutationTypes.getTrainingsTemplateSchoolIdStart)
    return new Promise((resolve) => {
      apiTrainingsTemplate
        .getTrainingsTemplateBySchoolId(params)
        .then((response) => {
          context.commit(
            mutationTypes.getTrainingsTemplateSchoolIdSuccess,
            response
          )
          resolve(response)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainingsTemplateSchoolIdFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
